import React, { useState } from 'react';
import axios from 'axios';

const SMSNotifications = ({ userData }) => {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phonenumber: '',
    notifications_enabled: false,
    acceptedterms: false
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.post('/api/sms-notifications', formData);
      setMessage('Thank you! Your SMS notification preferences have been saved.');
      setFormData({
        firstname: '',
        lastname: '',
        email: '',
        phonenumber: '',
        notifications_enabled: false,
        acceptedterms: false
      });
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = () => {
    // Redirect to home or dashboard
    window.location.href = '/';
  };

  const defaultAccessCard = userData?.accesscards?.find(
    ac => ac.accesscard_id === userData.default_accesscard_id
  );
  const schoolName = defaultAccessCard?.school?.school_name || 'Acuity CTE';
  const logoUrl = defaultAccessCard?.school?.logo_url || "https://acuitycte-files.s3.us-west-2.amazonaws.com/public/acuity-tech-logo.png";

  return (
    <div style={styles.container}>
      <div style={styles.backgroundPattern}></div>
      <div style={styles.formContainer}>
        {/* Header with close button */}
        <div style={styles.header}>
          <div style={styles.titleContainer}>
            <h1 style={styles.title}>Please provide your</h1>
            <h1 style={styles.title}>contact details</h1>
          </div>
          <button style={styles.closeButton} onClick={handleSkip}>
            <span style={styles.closeIcon}>×</span>
          </button>
        </div>

        {/* Logo and school name */}
        <div style={styles.logoSection}>
          <div style={styles.logoContainer}>
            <img src={logoUrl} alt="Logo" style={styles.logo} />
          </div>
          <h2 style={styles.schoolName}>{schoolName}</h2>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          {/* First Name */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              First name<span style={styles.required}>*</span>
            </label>
            <input
              type="text"
              name="firstname"
              value={formData.firstname}
              onChange={handleInputChange}
              placeholder="First Name Example"
              style={styles.input}
              required
            />
          </div>

          {/* Last Name */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>Last name</label>
            <input
              type="text"
              name="lastname"
              value={formData.lastname}
              onChange={handleInputChange}
              placeholder="Last Name Example"
              style={styles.input}
            />
          </div>

          {/* Email */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>
              Email<span style={styles.required}>*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="example@smsoptin.com"
              style={styles.input}
              required
            />
          </div>

          {/* Phone Number */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>Phone number</label>
            <input
              type="tel"
              name="phonenumber"
              value={formData.phonenumber}
              onChange={handleInputChange}
              placeholder="+1234567891"
              style={styles.input}
            />
          </div>

                     {/* Checkboxes */}
           <div style={styles.checkboxGroup}>
             <label style={styles.checkboxLabel}>
                              <div style={styles.checkboxContainer} className="checkboxContainer">
                  <input
                    type="checkbox"
                    name="notifications_enabled"
                    checked={formData.notifications_enabled}
                    onChange={handleInputChange}
                    style={styles.checkbox}
                  />
                  <div style={styles.checkboxCustom} className="checkboxCustom"></div>
                </div>
               <span style={styles.checkboxText}>
                 I would like to receive SMS notifications
               </span>
             </label>
           </div>

          <div style={styles.checkboxGroup}>
            <label style={styles.checkboxLabel}>
                             <div style={styles.checkboxContainer} className="checkboxContainer">
                 <input
                   type="checkbox"
                   name="acceptedterms"
                   checked={formData.acceptedterms}
                   onChange={handleInputChange}
                   style={styles.checkbox}
                   required
                 />
                 <div style={styles.checkboxCustom} className="checkboxCustom"></div>
               </div>
              <span style={styles.checkboxText}>
                               I accept the{' '}
               <a href="/terms" target="_blank" rel="noopener noreferrer" style={styles.link}>Terms of Service</a>
               {' '}and{' '}
               <a href="/privacy" target="_blank" rel="noopener noreferrer" style={styles.link}>Privacy Policy</a>
              </span>
            </label>
          </div>

          {/* SMS Consent Text */}
          <div style={styles.consentText}>
            <div style={styles.consentIcon}>📱</div>
            <div style={styles.consentContent}>
              By providing your phone number you agree to receive informational text messages from {schoolName}. 
              Consent is not a condition of purchase. Message frequency will vary. 
              Msg & data rates may apply. Reply HELP for help or STOP to cancel.
            </div>
          </div>

          {/* Messages */}
          {message && (
            <div style={styles.successMessage}>
              <div style={styles.messageIcon}>✓</div>
              {message}
            </div>
          )}
          {error && (
            <div style={styles.errorMessage}>
              <div style={styles.messageIcon}>⚠</div>
              {error}
            </div>
          )}

          {/* Buttons */}
          <div style={styles.buttonGroup}>
            <button
              type="button"
              onClick={handleSkip}
              style={styles.skipButton}
            >
              SKIP
            </button>
            <button
              type="submit"
              disabled={loading || !formData.acceptedterms}
              style={{
                ...styles.continueButton,
                ...(loading || !formData.acceptedterms ? styles.disabledButton : {})
              }}
            >
              {loading ? (
                <div style={styles.loadingContent}>
                  <div style={styles.spinner}></div>
                  SUBMITTING...
                </div>
              ) : (
                'CONTINUE'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    position: 'relative',
    overflow: 'hidden'
  },
  backgroundPattern: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `
      radial-gradient(circle at 20% 80%, rgba(29, 78, 137, 0.03) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(29, 78, 137, 0.03) 0%, transparent 50%),
      radial-gradient(circle at 40% 40%, rgba(29, 78, 137, 0.02) 0%, transparent 50%)
    `,
    pointerEvents: 'none'
  },
  formContainer: {
    maxWidth: '520px',
    width: '100%',
    backgroundColor: 'white',
    borderRadius: '20px',
    padding: '40px',
    boxShadow: '0 20px 60px rgba(29, 78, 137, 0.1)',
    position: 'relative',
    border: '1px solid rgba(29, 78, 137, 0.05)',
    backdropFilter: 'blur(10px)'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '30px'
  },
  titleContainer: {
    flex: 1
  },
  title: {
    color: '#1D4E89',
    fontSize: '28px',
    fontWeight: '700',
    margin: 0,
    lineHeight: '1.2',
    background: 'linear-gradient(135deg, #1D4E89 0%, #2E5A8A 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
  },
  closeButton: {
    background: 'rgba(29, 78, 137, 0.05)',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginLeft: '20px'
  },
  closeIcon: {
    fontSize: '20px',
    color: '#1D4E89',
    fontWeight: '600'
  },
  logoSection: {
    textAlign: 'center',
    marginBottom: '35px'
  },
  logoContainer: {
    display: 'inline-block',
    padding: '15px',
    backgroundColor: 'rgba(29, 78, 137, 0.02)',
    borderRadius: '15px',
    marginBottom: '15px'
  },
  logo: {
    height: '50px',
    width: 'auto',
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
  },
  schoolName: {
    color: '#1D4E89',
    fontSize: '20px',
    fontWeight: '600',
    margin: 0,
    letterSpacing: '0.5px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '25px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  label: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1D4E89',
    marginBottom: '4px',
    letterSpacing: '0.3px'
  },
  required: {
    color: '#e74c3c',
    marginLeft: '2px'
  },
  input: {
    padding: '16px 20px',
    border: '2px solid rgba(29, 78, 137, 0.1)',
    borderRadius: '12px',
    fontSize: '16px',
    outline: 'none',
    transition: 'all 0.3s ease',
    backgroundColor: 'rgba(29, 78, 137, 0.02)',
    color: '#333'
  },
  checkboxGroup: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '15px'
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '15px',
    fontSize: '14px',
    color: '#333',
    cursor: 'pointer',
    lineHeight: '1.5',
    flex: 1
  },
  checkboxContainer: {
    position: 'relative',
    flexShrink: 0
  },
  checkbox: {
    position: 'absolute',
    opacity: 0,
    cursor: 'pointer',
    height: 0,
    width: 0
  },
  checkboxCustom: {
    height: '20px',
    width: '20px',
    backgroundColor: 'white',
    border: '2px solid rgba(29, 78, 137, 0.3)',
    borderRadius: '4px',
    transition: 'all 0.3s ease',
    position: 'relative'
  },
  checkboxText: {
    flex: 1,
    paddingTop: '2px'
  },
  link: {
    color: '#1D4E89',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'color 0.3s ease'
  },
  consentText: {
    display: 'flex',
    gap: '12px',
    fontSize: '12px',
    color: '#666',
    lineHeight: '1.5',
    backgroundColor: 'rgba(29, 78, 137, 0.03)',
    padding: '16px',
    borderRadius: '12px',
    border: '1px solid rgba(29, 78, 137, 0.1)'
  },
  consentIcon: {
    fontSize: '16px',
    flexShrink: 0,
    marginTop: '2px'
  },
  consentContent: {
    flex: 1
  },
  successMessage: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    backgroundColor: '#d4edda',
    color: '#155724',
    padding: '16px',
    borderRadius: '12px',
    fontSize: '14px',
    border: '1px solid #c3e6cb'
  },
  errorMessage: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    backgroundColor: '#f8d7da',
    color: '#721c24',
    padding: '16px',
    borderRadius: '12px',
    fontSize: '14px',
    border: '1px solid #f5c6cb'
  },
  messageIcon: {
    fontSize: '16px',
    flexShrink: 0
  },
  buttonGroup: {
    display: 'flex',
    gap: '16px',
    marginTop: '10px'
  },
  skipButton: {
    flex: 1,
    padding: '16px 24px',
    backgroundColor: 'transparent',
    border: '2px solid rgba(29, 78, 137, 0.2)',
    color: '#1D4E89',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    borderRadius: '12px',
    transition: 'all 0.3s ease',
    letterSpacing: '0.5px'
  },
  continueButton: {
    flex: 1,
    padding: '16px 24px',
    background: 'linear-gradient(135deg, #1D4E89 0%, #2E5A8A 100%)',
    border: 'none',
    color: 'white',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    borderRadius: '12px',
    transition: 'all 0.3s ease',
    letterSpacing: '0.5px',
    boxShadow: '0 4px 15px rgba(29, 78, 137, 0.3)'
  },
  disabledButton: {
    opacity: 0.5,
    cursor: 'not-allowed',
    boxShadow: 'none'
  },
  loadingContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  spinner: {
    width: '16px',
    height: '16px',
    border: '2px solid rgba(255, 255, 255, 0.3)',
    borderTop: '2px solid white',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  }
};

// Add CSS for checkbox states and animations
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  /* Custom checkbox styling */
  .checkboxContainer input[type="checkbox"]:checked + .checkboxCustom {
    background-color: #1D4E89 !important;
    border-color: #1D4E89 !important;
  }
  
  .checkboxContainer input[type="checkbox"]:checked + .checkboxCustom::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 12px;
    font-weight: bold;
  }
  
  /* Alternative selector for better compatibility */
  input[type="checkbox"]:checked + .checkboxCustom {
    background-color: #1D4E89 !important;
    border-color: #1D4E89 !important;
  }
  
  input[type="checkbox"]:checked + .checkboxCustom::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 12px;
    font-weight: bold;
  }
  
  /* Input focus states */
  input[type="text"]:focus,
  input[type="email"]:focus,
  input[type="tel"]:focus {
    border-color: #1D4E89 !important;
    box-shadow: 0 0 0 3px rgba(29, 78, 137, 0.1) !important;
    background-color: white !important;
  }
  
  /* Button hover states */
  .skipButton:hover {
    background-color: rgba(29, 78, 137, 0.05) !important;
    border-color: rgba(29, 78, 137, 0.4) !important;
  }
  
  .continueButton:hover:not(:disabled) {
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 20px rgba(29, 78, 137, 0.4) !important;
  }
  
  .closeButton:hover {
    background-color: rgba(29, 78, 137, 0.1) !important;
    transform: scale(1.1) !important;
  }
  
  .link:hover {
    color: #2E5A8A !important;
  }
`;
document.head.appendChild(styleSheet);

export default SMSNotifications; 